/**
 * @generated by @interxfi/j5-codegen - do not edit */

import { buildMergedRequestInit, makeRequest } from '@interxfi/api-client/request';
import type { IxmUserauthV1RealmQueryServiceRealmGetRealmGetRequest, IxmUserauthV1RealmQueryServiceRealmGetResponse } from '@interxfi/types';

export const IXM_USERAUTH_V1_REALM_QUERY_SERVICE_REALM_GET_AUDIENCE = ['clearing', 'platform', 'program', 'organization'];

export async function ixmUserauthV1RealmQueryServiceRealmGet(baseUrl: string | undefined, request?: IxmUserauthV1RealmQueryServiceRealmGetRealmGetRequest, requestInit?: RequestInit): Promise<IxmUserauthV1RealmQueryServiceRealmGetResponse | undefined> { return makeRequest<IxmUserauthV1RealmQueryServiceRealmGetResponse, IxmUserauthV1RealmQueryServiceRealmGetRealmGetRequest>(...buildMergedRequestInit('GET', baseUrl || '', '/portal/userauth/v1/realm/q/:realmId', request, requestInit)); }

